import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

import { StorageService } from '../../services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CredenciaisService } from '../../services/credenciais.service';
import {REDIRECT_URL} from "../../util/constants";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  params = {
    code: null,
    id: null,
    page: null
  };

  usuarioLogado: any;
  isOuro:any =false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
    private loading: NgxSpinnerService,
    private toast: ToastrService,
    private credenciasService: CredenciaisService
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams: any) => {
      this.params.code = queryParams.code;
      this.route.params.subscribe((params: any) => {
        this.params.id = params.id;
        this.params.page = params.page;
        this.efetuarLogin();
      });
    });
  }

  async efetuarLogin() {
    try {
      let redirectUrl = '';
      if (this.params.id) {
        redirectUrl = `${REDIRECT_URL}/${this.params.page}/${this.params.id}`;
      } else {
        if (!this.params.page) {
          redirectUrl = REDIRECT_URL;
        } else {
          redirectUrl = `${REDIRECT_URL}/${this.params.page}`;
        }
      }
      await this.authService.getTokenBrasilCidadao(this.params.code, redirectUrl);
      await this.authService.loginScab();
      await this.authService.loginBarramento();
      this.usuarioLogado = await this.authService.getDadosUsuario();
      const loginBySolicitacao: boolean = localStorage.getItem('LOGIN_BY_SOLICITACAO_ACESSO') === 'SIM';
      if (loginBySolicitacao) {
        try{
          this.isOuro = await this.authService.buscarConfiabilidade();
        }catch(e){
          this.isOuro = false;
        }
        
        if(this.isOuro) {
          await this.router.navigateByUrl(localStorage.getItem('URL_SOLICITACAO_ACESSO'));
        }else{
          
          localStorage.setItem('REDIRECT_NOT_OURO', 'true');
          await this.router.navigateByUrl(localStorage.getItem('URL_DETALHE')); 
        }
        
        //window.open(localStorage.getItem('URL_SOLICITACAO_ACESSO') + '?cpf=' + this.usuarioLogado.cpf, '_self');
      } else {
        await this.router.navigateByUrl('/');
      }

      const minutes = 9;
      setInterval(async () => {
        await this.authService.loginScab();
        await this.authService.loginBarramento();
      }, minutes * 60000);
    } catch (e) {
      console.log('errrr', e);
      this.authService.logout();
      this.toast.error('Ocorreu um erro no login, tente novamente.');
      await this.router.navigateByUrl('/');
    } finally {
      this.loading.hide();
      localStorage.removeItem('URL_DETALHE');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts